import { render, staticRenderFns } from "./PazymaTurtas.vue?vue&type=template&id=a9c2823e&scoped=true&"
import script from "./PazymaTurtas.vue?vue&type=script&lang=js&"
export * from "./PazymaTurtas.vue?vue&type=script&lang=js&"
import style0 from "./PazymaTurtas.vue?vue&type=style&index=0&id=a9c2823e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c2823e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VSpacer,VTextField,VToolbar})
